export default __webpack_public_path__ + "img/documentation.014ebef5.png";